export const AdminRoles = ['SiteAdmin', 'Partner', 'SuperAdmin'];

export const Feature = Object.freeze({
  autoOnboardNewHire: 13,
  autoApplyEssChanges: 12,
  standardScheduling: 11,
  mobileApplication: 10,
  benefitsManagement: 9,
  centeralizedData: 8,
  advancedTime: 7,
  advancedHR: 5,
  hr: 2,
  platformPricing: 1,
});

export const FeatureKeys = Object.keys(Feature);

export const PermissionType = Object.freeze({
  viewSchedule: 'ViewSchedule',
  viewEmployee: 'ViewEmployee',
  modifySchedule: 'ModifySchedule',
  viewEmployeeRestricted: 'ViewEmployeeRestricted',
  modifyPassword: 'ModifyPassword',
  viewEmployeeContact: 'ViewEmployeeContact',
  modifyEmployeeContact: 'ModifyEmployeeContact',
  modifyEmployee: 'ModifyEmployee',
  modifyEmployeeRestricted: 'ModifyEmployeeRestricted',
  createEmployee: 'CreateEmployee',
  viewWages: 'ViewWages',
  modifyWages: 'ModifyWages',
  modifyPunches: 'ModifyPunches',
  modifyUnmatchedPunches: 'ModifyUnmatchedPunches',
  hubAdmin: 'HubAdmin',
  onboardingAdmin: 'OnboardingAdmin',
  benefitsAdmin: 'BenefitsAdmin',
  viewRoles: 'ViewRoles',
  modifyRoles: 'ModifyRoles',
  viewSettings: 'ViewSettings',
});

export const PermissionLevel = Object.freeze({
  none: 'None',
  self: 'Self',
  all: 'All',
  directReports: 'DirectReports',
  selfAndDirectReports: 'SelfAndDirectReports',
});

export const PermissionKeys = Object.keys(PermissionLevel);

export const NoPermissions = PermissionKeys.reduce((obj, key) => {
  return { ...obj, [key]: false };
}, {});
